const divModalFilterEquip = {
  cancel: 'CANCELAR',
  ok: 'APLICAR'
};

export default divModalFilterEquip;
